import { render, staticRenderFns } from "./SearchOccupations.vue?vue&type=template&id=1b2b680a&"
import script from "./SearchOccupations.vue?vue&type=script&lang=js&"
export * from "./SearchOccupations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports